import { render, staticRenderFns } from "./registpage.vue?vue&type=template&id=7e08b9f0&scoped=true&"
import script from "./registpage.vue?vue&type=script&lang=js&"
export * from "./registpage.vue?vue&type=script&lang=js&"
import style0 from "./registpage.vue?vue&type=style&index=0&id=7e08b9f0&scoped=true&lang=scss&"
import style1 from "./registpage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e08b9f0",
  null
  
)

export default component.exports